module.exports = __webpack_public_path__ + "media/landing-page/siusk24-ddc1c05e.png";